/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage your organization's subscription and access the billing portal." |
*
* @param {Payment_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const payment_subtitle = /** @type {((inputs?: Payment_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte das Abonnement deiner Organisation und greife auf das Abrechnungsportal zu.")
	return /** @type {LocalizedString} */ ("Manage your organization's subscription and access the billing portal.")
});